import { Carousel } from "../../../Animation/Carousel"
import styles from "@css/modules/ResortSections.module.scss"
import { ArrowDownSmall } from "@css/icons/SVG"
import { useMemo } from "react"

const classNames = {
    itemActive: styles.itemActive,
    item: styles.item,
    itemNext: styles.itemNext,
    itemPrev: styles.itemPrev,
    root: styles.carousel,
    dots: {
        item: styles.dotItem,
        root: styles.dotItemRoot,
        active: styles.dotItemActive
    }
}
const nextBtn = (onClick) => {
    return (
        <button onClick={onClick} className={styles.nextBtn} aria-label="go next">
            <ArrowDownSmall />
        </button>
    )
}
const prevBtn = (onClick) => {
    return (
        <button onClick={onClick} className={styles.prevBtn} aria-label="go prev">
            <ArrowDownSmall />
        </button>
    )
}
export function Gallery({ items = [] }) {
    const i = useMemo(
        () =>
            items?.map((img, key) => {
                return (
                    <div key={key}>
                        <img loading="lazy" className={styles.carouselImage} src={img.url} alt={img.alternativeText} height={img.height} width={img.width} />
                    </div>
                )
            }),
        [items]
    )
    if (!items?.length) return null
    return (
        <div className={styles.galleryRoot}>
            <Carousel startAt={0} autoplayTime={0} classNames={classNames} prevBtn={prevBtn} nextBtn={nextBtn} items={i} />
        </div>
    )
}
